import type { EntityEnum as IgnitionEntityEnum } from '@square/ignition/dist/types/entity';
import { AnchoredHeading } from '@squareup/dex-ui';
import { Markdown } from '@squareup/dex-ui-markdown';
import { Box, CodeField } from '@squareup/dex-ui-shared-base';
import { breakHtmlForUnderscoreReact } from '@squareup/dex-utils-text';
import React, { FunctionComponent } from 'react';

import { PropertyStatus } from '../../PropertyStatus';

interface EntityEnumProps {
  entityEnum: IgnitionEntityEnum;
  disableAnchor?: boolean;
}

/**
 */
const EntityEnum: FunctionComponent<EntityEnumProps> = ({
  entityEnum,
  disableAnchor,
}) => {
  const anchor = `value-${entityEnum.value}`;

  const displayName = () => {
    return (
      <CodeField>{breakHtmlForUnderscoreReact(entityEnum.value)}</CodeField>
    );
  };

  return (
    <>
      <Box margin={{ bottom: '1x' }}>
        {!disableAnchor ? (
          <AnchoredHeading
            trackingId="open-entity-enum-content"
            anchor={anchor}
            aria-label={`Copy link to ${entityEnum.value}`}
            aria-describedby={
              'Copies a link directly to this property into your clipboard'
            }
          >
            {displayName()}
          </AnchoredHeading>
        ) : (
          <Box>{displayName()}</Box>
        )}
      </Box>
      {entityEnum.releaseStatus === 'BETA' && (
        <PropertyStatus variant="beta">Beta</PropertyStatus>
      )}
      {entityEnum.releaseStatus === 'DEPRECATED' && (
        <PropertyStatus variant="deprecated">Deprecated</PropertyStatus>
      )}
      {entityEnum.releaseStatus === 'ALPHA' && (
        <PropertyStatus variant="alpha">Alpha</PropertyStatus>
      )}
      {entityEnum.label && (
        <Markdown markdown={entityEnum.label} textVariant="20"></Markdown>
      )}
    </>
  );
};

export { EntityEnum };
